import { useLayoutEffect, useEffect } from 'react';
import { gsap } from 'gsap';
import { Link } from 'react-scroll';
import styles from './headernav.module.scss';

interface HeaderNavProps {
  shouldAnimate: boolean;
}

const HeaderNav: React.FC<HeaderNavProps> = ({ shouldAnimate }) => {
  // Hide initially so it doesn't flash before animating in
  useLayoutEffect(() => {
    gsap.set('.navParent', { opacity: 0, x: 200 });
  }, []);

  // Slide in when name completes
  useEffect(() => {
    if (!shouldAnimate) return;
    const a1 = gsap.fromTo(
      '.navParent',
      { opacity: 0, x: 200 },
      { opacity: 1, x: 0, duration: 0.8, ease: 'power2.out' }
    );
    return () => { a1.kill(); };
  }, [shouldAnimate]);

  return (
    <nav className="navParent">
      <ul>
        <Link className={styles.defaultLink} activeClass={styles.defaultLinkActive} to="top-of-page" spy={true} smooth={true} offset={0} duration={500}>home</Link>
        <Link className={styles.defaultLink} activeClass={styles.defaultLinkActive} to="profile-section-root" spy={true} smooth={true} offset={0} duration={500}>profile</Link>
        <Link className={styles.defaultLink} activeClass={styles.defaultLinkActive} to="experiences-section-root" spy={true} smooth={true} offset={0} duration={500}>experiences</Link>
        <Link className={styles.defaultLink} activeClass={styles.defaultLinkActive} to="abilities-section-root" spy={true} smooth={true} offset={0} duration={500}>abilities</Link>
        <Link className={styles.defaultLink} activeClass={styles.defaultLinkActive} to="projects-section-root" spy={true} smooth={true} offset={0} duration={500}>projects</Link>
        <Link className={styles.defaultLink} activeClass={styles.defaultLinkActive} to="contact-section-root" spy={true} smooth={true} offset={0} duration={500}>contact</Link>
      </ul>
    </nav>
  );
};

export default HeaderNav;
